"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentPane = void 0;
var DocumentPane_1 = require("./src/DocumentPane");
Object.defineProperty(exports, "DocumentPane", { enumerable: true, get: function () { return __importDefault(DocumentPane_1).default; } });
//# sourceMappingURL=index.js.map